<ng-container [ngSwitch]="hasData">

    <table class="lxm-tree">
        <thead class="lxm-tree-headers">
            <th *ngFor="let colName of displayColumns" [class]="'lxm-tree-header lxm-tree-header-' + colName">
                <lxm-tree-header [colName]="colName" [templateRef]="headerRefs[colName]">
                </lxm-tree-header>
            </th>
        </thead>

        <tbody class="lxm-tree-nodes">
            <ng-container *ngFor="let child of children$ | async">
                <tr lxm-tree-node [class.hidden]="!isVisible(child)" [node]="child" [displayColumns]="displayColumns"
                    [cellRefs]="cellRefs">
                </tr>
            </ng-container>
        </tbody>
    </table>

    <no-content heading="cards.settings.clv.common.no_content.heading" text="cards.settings.clv.common.no_content.text"
        image="no-settings" *ngSwitchCase="false">
    </no-content>

</ng-container>